module.exports = __webpack_public_path__ + "static/img/tst2-10.5cb4923.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-10.jpg
// module id = 6WHX
// module chunks = 1